<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-19 18:35:10
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/list/components/OrderHeader/index.vue
-->
<template>
  <div class="clearfix order_header border_bottom1px">
    <img
      src="@/assets/order/icon_order1@2x.png"
      alt=""
      class="left left_icon"
    />
    <div class="left colo087 font14 font_weight500 line_height_20 header_title">
      {{ storeDet.storeName }}
    </div>
    <img
      v-if="
        storeDet.status === 13 ||
          storeDet.status === 14 ||
          storeDet.status === -10 ||
          storeDet.status === -11
      "
      src="@/assets/mine/icon_delete@2x.png"
      alt=""
      class="right right_delete"
      @click="clickBtn"
    />
    <!-- // 红色的状态字体
  .status_red_color {
    color: #d91818;
  } -->
    <div
      :class="{
        status_red_color:
          storeDet.status !== 13 &&
          storeDet.status !== 14 &&
          storeDet.status !== -10 &&
          storeDet.status !== -11
      }"
      class="right colo038 font12 font_weight400 line_height_20 header_status"
      @click="clickBtn"
    >
      {{ storeDet.status | statusDet }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    storeDet: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  filters: {
    statusDet(status) {
      switch (status) {
        case 10:
          return "待付款";
        case 11:
          return "待发货";
        case 12:
          return "待收货";
        case 13:
        case 14:
          return "已完成";
        case -10:
        case -11:
          return "已关闭";
      }
    }
  },
  methods: {
    clickBtn() {
      this.$emit("clickBtn", "删除订单", this.storeDet.orderSn);
    }
  }
};
</script>
<style lang="less" scoped>
.order_header {
  padding: 11px 0 9px;
  margin: 0 12px;
  .left_icon {
    width: 24px;
  }
  .header_title {
    padding: 4px 0 0 8px;
  }
  .header_status {
    padding-top: 4px;
  }
  .right_delete {
    width: 16px;
    margin: 4px 0 0 8px;
  }
  // 红色的状态字体
  .status_red_color {
    color: #d91818;
  }
}
</style>
